module.exports = __webpack_public_path__ + "media/images/icons/plan-1c2d93431e7718dc59e8ef2b7216ed6f.svg";